import React, { useState, useEffect } from "react";
// import emailjs from "emailjs-com";

// const publicAPI = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
// const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
// const templateID = "founders_form_template";

// emailjs.init(publicAPI);

const Form = ({ title, description, formType = "founders_circle" }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    let timer;
    if (successMessage) {
      timer = setTimeout(() => {
        setSuccessMessage("");
      }, 10000); // Clear message after 10 seconds
    }
    return () => clearTimeout(timer); // Cleanup timeout if component unmounts
  }, [successMessage]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isChecked) {
      setSuccessMessage("❌ Please agree to the Privacy Policy.");
      return;
    }
    
    setIsSubmitting(true);

    // Get form data
    const formData = {
      form_id: formType, // Using the formType prop
      firstName: e.target.firstName.value,
      lastName: e.target.lastName.value,
      email: e.target.email.value,
      message: e.target.message.value,
    };

    try {
      // Use Zapier webhook
      const proxyUrl = "https://hooks.zapier.com/hooks/catch/22621382/2xqdgvm/";
      
      const response = await fetch(proxyUrl, {
        method: "POST",
        body: JSON.stringify(formData),
      });

      // Parse response
      let data;
      try {
        data = await response.json();
      } catch (err) {
        console.error("Error parsing response:", err);
        throw new Error("Invalid server response");
      }

      if (!response.ok) {
        throw new Error(data.error || `Form submission failed: ${response.status}`);
      }

      console.log("Form submitted successfully:", data);
      setSuccessMessage("✅ Your message has been sent successfully!");
      e.target.reset(); // Clear form fields
      setIsChecked(false); // Uncheck the checkbox
    } catch (error) {
      console.error("Error submitting form:", error);
      setSuccessMessage("❌ Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="flex flex-wrap justify-center gap-10 py-8 px-6">
      <div className="w-full md:w-[563px] bg-[#fff9f5] p-8 rounded-lg shadow-lg">
        <h2 className="text-3xl md:text-4xl font-raleway text-left">{title || "Join the Founders' Circle"}</h2>
        <p className="text-sm md:text-base font-inter mt-4 text-left">{description || "Be Part of an Exclusive Group Shaping the Future"}</p>
        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          <div className="flex flex-col md:flex-row gap-4">
            <input
              type="text"
              name="firstName"
              placeholder="First Name*"
              className="flex-1 p-3 border border-gray-400 rounded mb-4 md:mb-0"
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name*"
              className="flex-1 p-3 border border-gray-400 rounded"
              required
            />
          </div>
          <input
            type="email"
            name="email"
            placeholder="Email*"
            className="w-full p-3 border border-gray-400 rounded"
            required
          />
          <textarea
            name="message"
            placeholder="Message"
            className="w-full p-3 border border-gray-400 rounded h-32"
          />
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="privacy"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="privacy" className="text-sm font-inter">
              I agree with our friendly Privacy Policy
              {/* Add a link to privacy policy if available */}
            </label>
          </div>
          <button
            type="submit"
            disabled={!isChecked || isSubmitting}
            className={`w-full ${isChecked && !isSubmitting ? "bg-[#3a6ea5]" : "bg-gray-400"} text-white text-lg md:text-xl font-raleway py-3 rounded mt-4`}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>

        {/* Success/Error Message */}
        {successMessage && (
          <div
            className={`mt-4 p-4 text-white text-center text-lg font-semibold rounded-lg ${successMessage.includes("successfully") ? "bg-[#039B86]" : "bg-red-500"}`}
          >
            {successMessage}
          </div>
        )}
      </div>
    </section>
  );
};

export default Form;
